import { composeIO } from 'react-compose-io'
import { modalControleComissaoStatusIO } from './ModalControleComissaoStatus.IO'
import ModalControleComissaoStatusView from './ModalControleComissaoStatus.View'

export const ModalControleComissaoStatus = composeIO(ModalControleComissaoStatusView, modalControleComissaoStatusIO)
